import Reveal from "../components/Reveal";
import LazyVideo from "../components/LazyVideo";
import { VIDEOS, POSTERS } from "../lib/media";

export default function FeaturedVideo() {
  return (
    <section className="bg-black pt-6 md:pt-10 pb-20 md:pb-32 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <div className="rounded-3xl overflow-hidden aspect-video relative">
            <LazyVideo
              className="w-full h-full object-cover"
              src={VIDEOS.featured}
              poster={POSTERS.featured}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />

            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
              <div className="liquid-glass rounded-2xl p-6 md:p-8 max-w-md">
                <div className="text-white/50 text-xs tracking-widest uppercase mb-3">Our Approach</div>
                <p className="text-white text-sm md:text-base leading-relaxed">
                  We start with the operating reality of your business: the data, the floor, the field. Then we build AI-native systems your teams actually use. No demoware. No bench. Just senior delivery, in production.
                </p>
              </div>
              <a href="/manifesto.html" className="liquid-glass rounded-full px-8 py-3 text-white text-sm font-medium hover:bg-white/5 transition-transform hover:scale-[1.03] active:scale-95">
                Explore more
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
